export const TRIAL_DAYS = 7; // 7 day trial period

export const PLANS = {
  INSTAGRAM_ONLY: {
    name: 'Instagram Only',
    description: 'Streamline your Instagram engagement',
    monthlyPrice: 9.99,
    yearlyPrice: 99.99,
    features: [
      'Instagram comment management',
      `${process.env.NEXT_PUBLIC_AI_REPLY_LIMIT_INSTAGRAM || '1,000'} AI replies per month`,
      'AI-powered response suggestions',
      'One-click answers',
      'Time-saving',
    ],
  },
  COMPLETE_PACKAGE: {
    name: 'Complete Package',
    description: 'Manage all your social platforms effortlessly',
    monthlyPrice: 19.99,
    yearlyPrice: 199.99,
    features: [
      'All Instagram Only features',
      `${process.env.NEXT_PUBLIC_AI_REPLY_LIMIT_COMPLETE || '2,000'} AI replies per month`,
      'Facebook, YouTube  and LinkedIn comment management',
      'Ads comment management',
      'Unified comment feed across platforms',
    ],
  },
} as const;

export type PlanType = keyof typeof PLANS;
